/* eslint-disable max-len */

import { EditButtonIcon, ShowButtonIcon } from "assets/Icons";
import { EditButton, ShowButton } from "react-admin";

const ShowAndEditDetails = ({
  title,
  view,
  icon,
  hasEdit = true,
  marginBottom = "16px",
  customButtons,
  borderBottom = "solid 1px rgba(48, 47, 46, 0.15)"
}: {
  title?: string;
  view?: string;
  icon?: JSX.Element;
  hasEdit?: boolean;
  marginBottom?: string;
  customButtons?: JSX.Element;
  borderBottom?: string;
}) => {
  return (
    <div
      className="w-full py-3 flex gap-3 justify-between items-center flex-wrap"
      style={{
        marginTop: view === "edit" ? "-16px" : "-10.5px",
        marginBottom: marginBottom,
        borderBottom: borderBottom
      }}
    >
      {title ? (
        <div className="flex items-center gap-[8px]">
          <div className="w-[32px] h-[32px] flex justify-center items-center rounded-[16px] bg-[#D9ECF1]">
            {icon}
          </div>
          <h5 className="font-['Inter'] text-[14px] text-[rgba(48,47,46,0.6)] font-[600] uppercase">
            {title}
          </h5>
        </div>
      ) : (
        <div />
      )}
      {customButtons || (
        <div className="flex flex-col gap-[8px] items-center customListActionsButtonsWrapper">
          {view === "edit" && (
            <ShowButton
              icon={<ShowButtonIcon />}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "36px",
                backgroundColor: "#FAF9F7",
                color: "rgba(48, 47, 46, 0.95)",
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 500,
                borderRadius: "18px",
                padding: "0px 16px",
                border: "1px solid rgba(48, 47, 46, 0.23)",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgba(48, 47, 46, 0.04)"
                }
              }}
            />
          )}
          {hasEdit && view === "show" && (
            <EditButton
              icon={<EditButtonIcon />}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "36px",
                backgroundColor: "#FAF9F7",
                color: "rgba(48, 47, 46, 0.95)",
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 500,
                borderRadius: "18px",
                padding: "0px 16px",
                border: "1px solid rgba(48, 47, 46, 0.23)",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgba(48, 47, 46, 0.04)"
                }
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ShowAndEditDetails;
